export const VENDORS = {
    GA4: "GA4",
    GA_ADS: "GA_ADS",
    CRITEO: "CRITEO",
    TABOOLA: "TABOOLA",
    FACEBOOK: "FACEBOOK",
    LINKEDIN: "LINKEDIN",
    MICROSOFT: "MICROSOFT",
    TRADE_TRACKER: "TRADE_TRACKER",
    TIK_TOK: "TIK_TOK"
} as const;

export type Vendor = typeof VENDORS[keyof typeof VENDORS];

export const VENDOR_IDS = {
    [VENDORS.GA4]: [10211, "s26"],
    [VENDORS.GA_ADS]: [755],
    [VENDORS.CRITEO]: [91],
    [VENDORS.TABOOLA]: [42],
    [VENDORS.FACEBOOK]: [20089],
    [VENDORS.LINKEDIN]: [804],
    [VENDORS.MICROSOFT]: [20326],
    [VENDORS.TRADE_TRACKER]: [10322],
    [VENDORS.TIK_TOK]: [10255]
} as const;

export type VendorIds = typeof VENDOR_IDS[Vendor];
